/** Catálogo unificado plataforma D28D + gym virtual. */
export const LIVE_CLASS_TYPE_OPTIONS_UNIFIED = [
  'METODO D28D',
  'FUERZA',
  'CARDIO',
  'FUNCIONAL',
  'ESPECIALES',
];

/** @deprecated Usar LIVE_CLASS_TYPE_OPTIONS_UNIFIED — se mantienen alias por compatibilidad. */
export const LIVE_CLASS_TYPE_OPTIONS_PLATFORM = [...LIVE_CLASS_TYPE_OPTIONS_UNIFIED];
export const LIVE_CLASS_TYPE_OPTIONS_GYM = [...LIVE_CLASS_TYPE_OPTIONS_UNIFIED];

export function liveClassTypeOptions(_gymScoped = false) {
  return [...LIVE_CLASS_TYPE_OPTIONS_UNIFIED];
}

export function mergeLiveClassTypeOptions(extra = []) {
  const out = [];
  const seen = new Set();
  for (const name of [...LIVE_CLASS_TYPE_OPTIONS_UNIFIED, ...(extra || [])]) {
    const key = String(name || '').trim().toLowerCase();
    if (!key || seen.has(key)) continue;
    seen.add(key);
    out.push(String(name).trim());
  }
  return out;
}

function normalizeToken(value) {
  return String(value || '')
    .trim()
    .toUpperCase()
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '');
}

/** Resuelve el tipo de clase de una grabación para filtros (canónico o inferido del título). */
export function resolveGalleryClassType(item, { gymScoped = false, catalog = null } = {}) {
  const options = Array.isArray(catalog) && catalog.length
    ? catalog
    : liveClassTypeOptions(gymScoped);
  const raw = normalizeToken(item?.class_type);
  if (raw) {
    const exact = options.find((opt) => normalizeToken(opt) === raw);
    if (exact) return exact;
    const partial = options.find((opt) => raw.includes(normalizeToken(opt).split(' ')[0]));
    if (partial) return partial;
  }
  const title = normalizeToken(item?.title);
  if (title.includes('METODO')) return 'METODO D28D';
  if (title.includes('FUERZA')) return 'FUERZA';
  if (title.includes('CARDIO')) return 'CARDIO';
  if (title.includes('FUNCIONAL')) return 'FUNCIONAL';
  if (title.includes('ESPECIAL')) return 'ESPECIALES';
  return item?.class_type ? String(item.class_type).trim() : '';
}
